import * as z from "zod/v4";

export const submitImageFeedback = {
  name: "submitImageFeedback" as const,
  input: z.object({
    imageId: z.string(),
    imageType: z.enum(["productFamily", "product"]),
    feedback: z.enum(["positive", "negative"]).nullable(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
